/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { v4 } from "uuid";
import { Box, Spacer, Text } from "@nordcloud/gnui";
import { FlexContainer, QueryPagination } from "~/components";
import { LoaderWrap } from "~/components/LoaderWrap/LoaderWrap";
import { AssignProduct } from "~/components/Product/AssignProduct";
import { ProductItem } from "~/components/Product/ProductItem";
import { AssignedProduct } from "~/components/Product/types";
import { useUserConsumer } from "~/context/User/User";
import { isStandardUser } from "~/routing";
import { useProducts } from "./hooks/useProducts";

function Products() {
  const { products, isLoading, fetchProducts } = useProducts();

  type ProductId = {
    idV4: string;
    item: AssignedProduct;
  };
  const productsAddId = products?.map((item) => ({
    idV4: v4(),
    item,
  }));

  const { role } = useUserConsumer();
  const canEdit = isStandardUser(role);

  return (
    <Box>
      <FlexContainer justify="flex-end" css={{ margin: "0 0 0 auto" }}>
        <AssignProduct assignedProducts={products} refetch={fetchProducts} />
      </FlexContainer>
      <Spacer height="1rem" />

      <LoaderWrap loading={isLoading}>
        {productsAddId.length > 0 ? (
          <>
            {productsAddId.map((product: ProductId) => (
              <ProductItem
                key={product.idV4}
                refetch={fetchProducts}
                item={product.item}
                canEdit={canEdit}
              />
            ))}
            <QueryPagination count={Number(products?.length) || 0} />
          </>
        ) : (
          <Text>No products assigned.</Text>
        )}
      </LoaderWrap>
    </Box>
  );
}

export { Products };
